module.exports = __webpack_public_path__ + "img/alert6.f76d2205.png";